import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import logo from '../../assets/logo.jpg'

import { Link as ScrollLink } from 'react-scroll';
import './Navbar.css'


const drawerWidth = 240;

function Navbar(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };
  const scrollToTop = () => {
    const HomeSection = document.getElementById('home');
    if (HomeSection) {
      HomeSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const scrollToService = () => {

    const serviceSection = document.getElementById('service');
    if (serviceSection) {
      serviceSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const scrollToEmail = () => {
    const aboutUsSection = document.getElementById('email');
    if (aboutUsSection) {
      aboutUsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const scrollToTrustBy = () => {
    const contactSection = document.getElementById('trustBy');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center', backgroundColor: '#101010', height: 900 }}>
      <Typography variant="h6" sx={{ my: 2, }}>
        <img src={logo} style={{ width: 100 }} alt="" />
      </Typography>
      <Divider style={{ backgroundColor: 'white', marginTop: '30px', marginBottom: '30px' }} />
      <List>
        <ListItem disablePadding style={{ display: 'flex', flexDirection: 'column', }}>
          <ListItemButton sx={{ textAlign: 'center', color: 'white' }}>
            <ScrollLink
              to="home"
              smooth={true}
              duration={500}
              onClick={scrollToTop}
              style={{ cursor: 'pointer', fontSize: '15px' }}
              sx={{ textAlign: 'center', color: 'white' }}
            >
              Home
            </ScrollLink>
          </ListItemButton>
          <ListItemButton sx={{ textAlign: 'center', color: 'white' }}>
            <ScrollLink
              to="service"
              smooth={true}
              duration={500}
              onClick={scrollToService}
              style={{ cursor: 'pointer', fontSize: '15px' }}
            >
              Service
            </ScrollLink>
          </ListItemButton>
          <ListItemButton sx={{ textAlign: 'center', color: 'white' }}>
            <ScrollLink
              to="aboutUs"
              smooth={true}
              duration={500}
              onClick={scrollToEmail}
              style={{ cursor: 'pointer', fontSize: '15px' }}
            >
              Contact Us
            </ScrollLink>
          </ListItemButton>
          <ListItemButton sx={{ textAlign: 'center', color: 'white' }}>
            <ScrollLink
              to="contact"
              smooth={true}
              duration={500}
              onClick={scrollToTrustBy}
              style={{ cursor: 'pointer', fontSize: '15px' }}
            >
              Trusted By
            </ScrollLink>
          </ListItemButton>

        </ListItem>
      </List>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar component="nav" sx={{ backgroundColor: '#101010' }} >
        <Toolbar >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            component="div"
            sx={{
              flexGrow: 1,
              display: {
                xs: 'flex', // 'flex' display for extra-small screens
                sm: 'block', // revert to 'block' display for small screens and above
              },
              justifyContent: {
                xs: 'center', // center content for small screens and above
              },
            }}
            style={{
              marginRight: '30px'
            }}
          >
            <img src={logo} style={{ width: 100, marginLeft: 30, marginTop: 5 }} alt="" />
          </Typography>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <ScrollLink
              to="home"
              smooth={true}
              duration={500}
              onClick={scrollToTop}
              style={{ cursor: 'pointer', marginRight: 40, fontSize: '20px' }}
            >
              Home
            </ScrollLink>
            <ScrollLink
              to="service"
              smooth={true}
              duration={500}
              onClick={scrollToService}
              style={{ cursor: 'pointer', marginRight: 40, fontSize: '20px' }}
            >
              Service
            </ScrollLink>
            <ScrollLink
              to="aboutUs"
              smooth={true}
              duration={500}
              onClick={scrollToEmail}
              style={{ cursor: 'pointer', marginRight: 40, fontSize: '20px' }}
            >
              Contact Us
            </ScrollLink>
            <ScrollLink
              to="contact"
              smooth={true}
              duration={500}
              onClick={scrollToTrustBy}
              style={{ cursor: 'pointer', marginRight: 40, fontSize: '20px' }}
            >
              Trused By
            </ScrollLink>
          </Box>
        </Toolbar>
      </AppBar>
      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}

        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main" sx={{ p: 3 }}>

      </Box>
    </Box>
  );

}

Navbar.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};
export default Navbar;